import {
  BACKGROUND_VIMEO_VIDEO,
  PREFIX_YOUTUBE,
  PREFIX_VIMEO
} from '@/utils/constants'

const Common = {
  filters: {
    truncate: function(string, length, suffix, offset) {
      offset = typeof offset === 'undefined' ? 0 : offset
      if (string && string.length > length) {
        return string.substring(0, length - offset) + suffix
      }
      return string
    },
    pluralize: function(n) {
      return n === 1 ? 'position' : 'positions'
    },
    capitalize: function(value) {
      if (!value) return ''
      value = value
        .toString()
        .toLowerCase()
        .trim()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    formatNumber: function(value) {
      return Intl.NumberFormat('en-EN', { maximumSignificantDigits: 3 }).format(
        value
      )
    },
    formatAmount(value) {
      let tempAmount = (value + '.00').replace(/\d(?=(\d{3})+\.)/g, '$&,')
      tempAmount = tempAmount.substr(0, tempAmount.length - 3)
      return tempAmount
    }
  },
  methods: {
    setVideoYoutube: function(url) {
      let youtubeRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/
      let vimeoRegex = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i
      let match = url.match(youtubeRegex)
      if (!match) {
        match = url.match(vimeoRegex)
        return match
          ? PREFIX_VIMEO + match[1] + BACKGROUND_VIMEO_VIDEO
          : PREFIX_VIMEO
      } else {
        return match && match[2].length === 11
          ? PREFIX_YOUTUBE + match[2] + '?'
          : PREFIX_YOUTUBE
      }
    },
    checkFileImage: function(avatarFile) {
      return /\.(gif|jpg|jpeg|tiff|png)$/i.test(avatarFile.name)
    },
    checkFileVideo: function(File) {
      return /\.(mp4)$/i.test(File.name)
    },
    checkPriorityOfVideoUrl: function(youtubeUrl, profileVideoMp4) {
      if (youtubeUrl) {
        if (profileVideoMp4) {
          return false
        }
        return true
      }
      return false
    },
    setBackPage: function(section, status) {
      let playload = {
        section: section,
        status: status
      }
      this.$store.commit('setAllowBackPage', playload)
    },
    normalizer: function(node) {
      return {
        id: node.id,
        label: node.name
      }
    },
    normalizerMultiSelect: function(node) {
      return {
        id: node.name,
        label: node.name
      }
    },
    normalizerLevelSelection: function(node) {
      return {
        id: node.key,
        label: node.name
      }
    }
  }
}

export default Common



// WEBPACK FOOTER //
// ./src/mixins/Common.js